module.exports = __webpack_public_path__ + "static/smart_tradycyjne-bdf74da1d2a6ff27601d81d8e3f94076.png";